import * as React from 'react'
import ButtonContainer from 'components/ui/button-container'
import InlineLink from 'components/ui/inline-link'
import styles from './index.module.css'

type Props = {
  playlistUrl: string
  setDiscoPlaylist: (...args: Array<any>) => any
  changeUrlParams: {
    path: string
    groupId: string
    groupName: string
    search: string
  }
}

const DiscoPlaylistActions = ({
  playlistUrl,
  changeUrlParams: { path, groupId, groupName, search },
  setDiscoPlaylist,
}: Props): React.ReactNode => (
  <ButtonContainer className={styles.discoPlaylistActions}>
    <InlineLink to={playlistUrl} target="_blank" rel="noopener noreferrer">
      View playlist
    </InlineLink>
    <InlineLink
      to={{
        pathname: `/${path}/${groupId}/${groupName}/select-playlist`,
        search,
      }}
    >
      Change playlist
    </InlineLink>
    <InlineLink onClick={() => setDiscoPlaylist(null)}>
      Remove playlist
    </InlineLink>
  </ButtonContainer>
)

export default DiscoPlaylistActions
